// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Button, GoalsIllustration, Stack, Tile, Typography, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { AppointmentsAvatar } from "./AppointmentsAvatar"
import type { Provider } from "./types"

// Placeholder data for scaffolding only. Will be replaced with data from the API.
const providers: Provider[] = [
  { name: "Marcus Reed", title: "MD", photoUrl: null },
  { name: "Bob Smith", title: "MD", photoUrl: null },
  { name: "John Doe", title: "MD", photoUrl: null },
  { name: "Joe Schmo", title: "MD", photoUrl: null }
]

export function MainCard(): JSX.Element {
  const theme = useTheme()
  // TODO: Add variations for this card based on the user's visit history
  return (
    <Tile variant="primary" color="primary" illustration={<GoalsIllustration />}>
      <Stack
        sx={{ flexDirection: "column", alignItems: "flex-start" }}
        spacing={theme.spacing(theme.tokens.spacing.md)}
        width="70%"
      >
        <Stack
          sx={{ flexDirection: "row", justifyContent: "flex-start" }}
          spacing={theme.spacing(theme.tokens.spacing.xs)}
        >
          {providers.slice(0, 3).map((provider) => (
            <AppointmentsAvatar key={provider.name} name={provider.name} photoUrl={provider.photoUrl} />
          ))}
        </Stack>
        <Typography variant="h6">Ready to see a provider from home?</Typography>
        <Typography>Book a virtual visit with a Carrot Clinic clinician for clinical support and guidance.</Typography>
        <Button variant="outlined" color="secondary">
          Book a visit
        </Button>
      </Stack>
    </Tile>
  )
}
